import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DealerQueue } from 'src/app/shared/models/backoffice/queue-cases/dealer-queue.model';

@Injectable()
export class DealerQueueService {
  private readonly httpClient = inject(HttpClient);
  private readonly schedulerApiUrl = '/api/scheduler';

  getDealerQueue(dealer: string): Observable<DealerQueue> {
    return this.httpClient.get<DealerQueue>(`${this.schedulerApiUrl}/queue/${dealer}`);
  }

  moveScheduledToQueue(dealer: string, caseId: number, bulkId: string): Observable<void> {
    const params = new HttpParams()
      .set('type', 'FROM_SCHEDULED_TO_QUEUE')
      .set('bulkId', bulkId);
    return this.httpClient.put<void>(`${this.schedulerApiUrl}/queue/${dealer}/${caseId}`, {}, { params });
  }

  reorder(dealer: string, from: number, to: number): Observable<void> {
    const params = new HttpParams()
      .set('from', from.toString())
      .set('to', to.toString());
    return this.httpClient.put<void>(`${this.schedulerApiUrl}/queue/${dealer}/reorder`, {}, { params });
  }
}
